export interface AccountsResponse {
  source: string;
  account: AccountType[];
}

export interface AccountType {
  id: number;
  name: string;
  seat_id: number;
}

export interface CampaignsResponse {
  source: string;
  accountId: string;
  campaigns: CampaignType[];
}

export interface CampaignType {
  id: number;
  name: string;
}

export interface TimeSeriesDataPoint {
  date: string;
  impressions: number;
  clicks: number;
  views: number;
  interactions: number;
  spend: number;
  conversions: number;
  video_starts: number;
  video_completes: number;
  audio_starts: number;
  audio_completes: number;
  ctr?: number;
  cpm?: number;
  cpa?: number;
  [key: string]: string | number | undefined;
}

export interface RawDataPoint {
  date: string;
  campaign_name: string;
  campaign_id: number;
  line_item_name: string | null;
  line_item_id: number | null;
  impressions: number;
  clicks: number;
  views: number;
  interactions: number;
  spend: number;
  conversions: number;
  video_starts: number;
  video_completes: number;
  audio_starts: number;
  audio_completes: number;
  [key: string]: string | number | null | undefined;
}

export interface ReportMetrics {
  current: MetricData;
  past: MetricData;
  dif: MetricData;
}

export interface MetricData {
  impressions: number;
  clicks: number;
  views: number;
  spend: number;
  conversions: number;
  // reach: number;
  ctr: number;
  cpc: number;
  cpm: number;
  cpa: number;
  video_starts: number;
  video_completes: number;
  audio_starts: number;
  audio_completes: number;
  start_date?: string;
  end_date?: string;
  [key: string]: number | string | undefined;
}

export interface ChatMessage {
  type: 'human' | 'ai';
  content: string;
}

export interface ChatItem {
  id: string;
  type: string;
  version: number;
}

export interface ChatContext {
  sources: string[];
  account_ids: string[];
  campaign_ids: string[] | null;
  start_date: string;
  end_date: string | null;
}

export interface ChatResponse {
  thread_id: string;
  decision: string;
  messages: ChatMessage[];
  items: ChatItem[];
  context: ChatContext;
}

export interface ChatRequest {
  user_input: string;
  source: string;
  account_ids: number[];
  campaign_ids: number[];
  start_date: string;
  end_date: string;
  thread_id?: string;
}

export enum AIGeneratedItemType {
  Summary = 'campaign_report_summary',
  Detailed = 'campaign_report_detailed',
  Email = 'campaign_report_email'
}

export interface AIGeneratedItem {
  id: string;
  type: AIGeneratedItemType;
  version: number;
}

export interface AIGeneratedItemResponse {
  id: string;
  created_at: string;
  updated_at: string;
  status: string | null;
  item_id: string;
  item_type: string;
  source: string;
  account_ids: string[] | null;
  campaign_ids: string[] | null;
  start_date: string;
  end_date: string | null;
  item: string;
  version: number;
  created_by: string;
}

export interface TableDataPoint {
  key: string; // Zipcode, domain, app
  spend: number;
  impressions: number;
  clicks: number;
  conversions: number;
  ctr: number;
  cpc: number;
  cpm: number;
  cpa: number;
}